<template>
	<div>
		<button class="btn btn-secondary mb-2" type="button" v-on:click.prevent="addBien">
			<i class="material-icons">add_circle</i>
			Agregar
		</button>
		<div v-if="errors && errors['bien_asegurado']" class="text-danger">
			{{errors['bien_asegurado'][0]}}
		</div>
		<div class="table-responsive" v-if="bienes.length>0">
			<table class="table table-borderless table-hover table-sm">
				<thead>
					<tr>
						<th class="text-center">Bien Asegurado</th>
						<th width="120px" class="text-center">Suma Asegurada</th>
						<th width="120px" class="text-center">Deducible 1</th>
						<th width="120px" class="text-center">Deducible 2</th>
						<th width="120px" class="text-center">Prima Neta</th>
						<th width="120px" class="text-center">Prima Total</th>
						<th class="text-center">Observaciones</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in bienes" :class="{'table-danger':errors && errors['bien_asegurado.'+index]}">
						<td>
							<input type="text" :name="'bien_asegurado['+index+'][DESCRIPCION_BIEN]'" class="form-control form-control-sm" v-model="item.DESCRIPCION_BIEN">
							<div v-if="errors && errors['bien_asegurado.'+index+'.DESCRIPCION_BIEN']" class="text-danger">
								{{errors['bien_asegurado.'+index+'.DESCRIPCION_BIEN'][0]}}
							</div>
						</td>
						<td>
							<decimal type="text" :name="'bien_asegurado['+index+'][SUMA_ASEGURADA]'" class="form-control form-control-sm" v-model="item.SUMA_ASEGURADA" min="0"></decimal>
							<div v-if="errors && errors['bien_asegurado.'+index+'.SUMA_ASEGURADA']" class="text-danger">
								{{errors['bien_asegurado.'+index+'.SUMA_ASEGURADA'][0]}}
							</div>
						</td>
						<td>
							<decimal type="text" :name="'bien_asegurado['+index+'][DEDUCIBLE1]'" class="form-control form-control-sm" v-model="item.DEDUCIBLE1" min="0"></decimal>
							<div v-if="errors && errors['bien_asegurado.'+index+'.DEDUCIBLE1']" class="text-danger">
								{{errors['bien_asegurado.'+index+'.DEDUCIBLE1'][0]}}
							</div>
						</td>
						<td>
							<decimal type="text" :name="'bien_asegurado['+index+'][DEDUCIBLE2]'" class="form-control form-control-sm" v-model="item.DEDUCIBLE2" min="0"></decimal>
							<div v-if="errors && errors['bien_asegurado.'+index+'.DEDUCIBLE2']" class="text-danger">
								{{errors['bien_asegurado.'+index+'.DEDUCIBLE2'][0]}}
							</div>
						</td>
						<td>
							<decimal type="text" :name="'bien_asegurado['+index+'][PRIMA_NETA]'" class="form-control form-control-sm" v-model="item.PRIMA_NETA" min="0"></decimal>
							<div v-if="errors && errors['bien_asegurado.'+index+'.PRIMA_NETA']" class="text-danger">
								{{errors['bien_asegurado.'+index+'.PRIMA_NETA'][0]}}
							</div>
						</td>
						<td>
							<decimal type="text" :name="'bien_asegurado['+index+'][PRIMA_TOTAL]'" class="form-control form-control-sm" v-model="item.PRIMA_TOTAL" min="0"></decimal>
							<div v-if="errors && errors['bien_asegurado.'+index+'.PRIMA_TOTAL']" class="text-danger">
								{{errors['bien_asegurado.'+index+'.PRIMA_TOTAL'][0]}}
							</div>
						</td>
						<td>
							<textarea type="text" :name="'bien_asegurado['+index+'][OBSERVACIONES]'" class="form-control form-control-sm" v-model="item.OBSERVACIONES" maxlength="250"></textarea>
							<div v-if="errors && errors['bien_asegurado.'+index+'.OBSERVACIONES']" class="text-danger">
								{{errors['bien_asegurado.'+index+'.OBSERVACIONES'][0]}}
							</div>
						</td>
						<td width="50px">
							<div class="table-hover-options">
								<button type="button" v-on:click="deleteBien(index)" class="btn btn-sm btn-link text-muted" v-if="roleUser() != 'V'">
								<i class="material-icons">delete</i>
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-else class="text-center text-muted py-3">
			No se ha agregado ningún Bien Asegurado.
		</div>
	</div>
</template>
<script>
	export default {
		props: ['data', 'error'],

		data(){
			return {
				bienes: [],
				bien: '',
				errors: []
			}
		},

		mounted() {
			var datos = JSON.parse(this.data)
			if (datos != null) {
				this.bienes = datos || []
			}

			this.errors = this.errorsData || {}
		},

		methods: {
			addBien: function(){
				this.bienes.push({
					DESCRIPCION_BIEN: '',
					SUMA_ASEGURADA: 0,
					DEDUCIBLE1: 0,
					DEDUCIBLE2: 0,
					PRIMA_NETA: 0,
					PRIMA_TOTAL: 0,
					OBSERVACIONES: ''
				})
			},

			deleteBien: function(index){
				this.bienes.splice(index, 1)
				this.errors = {}
			}
		},

		computed: {
			errorsData: function(){
				return JSON.parse(this.error)
			},
		},

		watch: {
			bienes: {
				handler: function(val, oldVal){
					let suma = [];
					let deducible1 = [];
					let deducible2 = [];
					let neta = [];
					let total = [];

					Object.entries(val).forEach(([key, val]) => {
						suma.push(val.SUMA_ASEGURADA)
						deducible1.push(val.DEDUCIBLE1)
						deducible2.push(val.DEDUCIBLE2)
						neta.push(val.PRIMA_NETA)
						total.push(val.PRIMA_TOTAL)
					});

					var tsuma = suma.reduce(function(total, num){ 
						return +(total || 0).toString().replace(/[^0-9.]/g, "") + +(num || 0).toString().replace(/[^0-9.]/g, "")
					}, 0);
					var tdeducible1 = deducible1.reduce(function(total, num){
						return +(total || 0).toString().replace(/[^0-9.]/g, "") + +(num || 0).toString().replace(/[^0-9.]/g, "")
					}, 0);
					var tdeducible2 = deducible2.reduce(function(total, num){
						return +(total || 0).toString().replace(/[^0-9.]/g, "") + +(num || 0).toString().replace(/[^0-9.]/g, "")
					}, 0);
					var tneta = neta.reduce(function(total, num){ 
						return +(total || 0).toString().replace(/[^0-9.]/g, "") + +(num || 0).toString().replace(/[^0-9.]/g, "")
					}, 0);
					var ttotal = total.reduce(function(total, num){ 
						return +(total || 0).toString().replace(/[^0-9.]/g, "") + +(num || 0).toString().replace(/[^0-9.]/g, "")
					}, 0);

					$('#suma_asegurada').val(tsuma.toFixed(2)).trigger('input')
					$('#deducible1').val(tdeducible1.toFixed(2)).trigger('input')
					$('#deducible2').val(tdeducible2.toFixed(2)).trigger('input')
					$('#prima_neta').val(tneta.toFixed(2)).trigger('input')
					$('#prima_total').val(ttotal.toFixed(2)).trigger('input')

				},
				deep:true
			}
		}
	}
</script>